import JobIcon from '@mui/icons-material/FeaturedPlayList'

import StageShow from './StageShow'

const resource = {
  show: StageShow,
  icon: JobIcon
}

export default resource